import React, { useCallback, useContext, useState, useRef, useEffect } from 'react';

import * as S from './CaseStudiesStyles';
import DisplayContext from '../../../UtilityComponents/displayContext';
import {
	ResponsiveContainer,
	Heading,
	Card,
	GenericP,
	GenericSpan,
	FlexDiv
} from 'commonStyles';
import Button from '../../../common/Button/Button';
import { loadNextComponent, scrollToElem, trackClickEvents } from '../../utils';
import { getMybizCaseStudy } from '../../landingApi';
import Loader from '../../../common/Loader/Loader';
import { CaseStudiesTempData } from '../../config';
import { LandingSpriteIcon } from '../../Styles';
import landingContext from '../../landingContext';
import { ASSET_PATH } from 'assetsPath';
import { ADOBE_EVENT_VALUES, PATHS } from 'AppConstants';

const SHOW_COUNT = 2;

const CaseStudies = ({ showNextComp, nextComp, isScollView, isCorpSeo }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const { appSsrData = { caseStudy: [] } } = useContext(landingContext) || {};
	const isMobile = displayName == 'mobile';

	const [caseCount, setCaseCount] = useState(SHOW_COUNT);
	const [caseStudiesData, setCaseStudiesData] = useState((isCorpSeo ? CaseStudiesTempData.list : appSsrData?.caseStudy) || []);
	const { heading, subHeading } = CaseStudiesTempData;

	const refHtml = useRef();

	const getDetails = useCallback(async () => {
		if (!appSsrData?.caseStudy?.length) {
			const response = await getMybizCaseStudy();
			setCaseStudiesData(response.caseStudy);
		}
	}, [setCaseStudiesData]);

	useEffect(() => {
		loadNextComponent(refHtml, showNextComp, nextComp);
		getDetails();
	}, []);

	useEffect(() => {
		if (isScollView && refHtml.current) {
			if (refHtml.current) {
				setTimeout(() => {
					scrollToElem(refHtml);
				}, 300);
			}
		}
	}, [isScollView]);

	const showAll = ()=>{
		setCaseCount((caseCnt) => (caseCnt > SHOW_COUNT ? SHOW_COUNT : caseStudiesData.length));
		trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.VIEW_ALL);
	};

	return (
		<ResponsiveContainer as='section' id='CaseStudies' ref={refHtml}>
			<S.BgPurple>
				<Heading
					as='h3'
					font_size={`${isMobile ? '28' : '48'}`}
					color='#fff'
					marBt='24px'>
					{heading}
				</Heading>
				<GenericP color='#fff' fsize={isMobile ? '14px' : '22px'}>
					{subHeading}
				</GenericP>

				{!caseStudiesData ? <Loader color='#723b63' /> :
				<S.CaseStudiesCardWrap>
					{caseStudiesData && !caseStudiesData.error && caseStudiesData.slice(0, caseCount).map((data, index) => {
						const { company, heading, description, pdfUrl } = data;
						return (
							<Card as='article' radius='7.2px' key={index} itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/Article`}>
								<FlexDiv bottom_M='20' justify='flex-start'>
									<LandingSpriteIcon icon='icNote' />
									<GenericSpan itemProp='author' itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/Person`} left_M='8'>
										<span itemProp='name'>{company}</span>
										<meta itemProp='url' content={company} />
									</GenericSpan>
								</FlexDiv>
								<Heading as='h3' f_weight='900' font_size={`${isMobile ? '16' : '24'}`} color='#3b385e' itemProp='headline'>
									{heading}
								</Heading>
								<meta itemProp='image' content={`${ASSET_PATH.IMAGES}landing_NewSprite1.png`} />
								<meta itemProp='url' content={pdfUrl} />
								<GenericP itemProp='articleBody' fsize='16px' bottom_P='20' top_P='20'>
									{description}
								</GenericP>
								<Button
									btnTxt='READ STORY'
									btnType='Flat'
									btnName='Secondary'
									btnShadow
									btnWidth={`${isMobile ? '100%' : '33%'}`}
									height='44px'
									isSeoAnchor
									seoUrl={pdfUrl}
									handleClick={() => {
										trackClickEvents(`${ADOBE_EVENT_VALUES.LANDING?.READ_STORY}_${index + 1}_clicked`);
										window.open(pdfUrl);
									}}
								/>
							</Card>
						);
					})}
				</S.CaseStudiesCardWrap>}
				{caseStudiesData.length > SHOW_COUNT && <S.ViewAllStoriesLink onClick={showAll}>{caseCount <= SHOW_COUNT ? 'VIEW ALL' : 'HIDE'} {caseCount <= SHOW_COUNT ? caseStudiesData.length - SHOW_COUNT : ''} STORIES<span /></S.ViewAllStoriesLink>}
			</S.BgPurple>
		</ResponsiveContainer>
	);
};

export default CaseStudies;
